"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('OneToOne', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white",
    fillOpacity: "0.01"
  }), _react.default.createElement("path", {
    d: "M42 7H6C4.89543 7 4 7.89543 4 9V39C4 40.1046 4.89543 41 6 41H42C43.1046 41 44 40.1046 44 39V9C44 7.89543 43.1046 7 42 7Z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "4"
  }), _react.default.createElement("path", {
    d: "M12 20.5799L16 18V30",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M31 20.5799L35 18V30",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M24 20V21",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M24 27V28",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round"
  }));
});

exports.default = _default;